import { Button, Layout, Space, Typography } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const { Footer } = Layout
const { Text } = Typography

export const FooterLayout: React.FC = () => {
  const navigate = useNavigate()
  const year = new Date().getFullYear()

  return (
    <Footer style={{ textAlign: 'center', backgroundColor: '#f8f8f2' }}>
      <Space vertical>
        <Space wrap style={{ justifyContent: 'center' }}>
          <Button type="text" onClick={() => navigate('/legal-notice')}>
            <Text style={{ fontWeight: 300 }}>Mentions légales</Text>
          </Button>
          <Button type="text" onClick={() => navigate('/data-privacy')}>
            <Text style={{ fontWeight: 300 }}>
              Politique de confidentialité
            </Text>
          </Button>
        </Space>
        <Text style={{ fontWeight: 300 }}>© {year} Paris Society</Text>
      </Space>
    </Footer>
  )
}
